import React, { useState } from "react"
import DatePicker from "react-datepicker"
import { PencilSquareIcon, TrashIcon } from "@heroicons/react/24/outline"
import api from "../../../../utils/axios"

const iconButtonClassName =
	"tw-inline-flex tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-slate-200 tw-bg-white tw-p-1.5 tw-text-slate-600 tw-shadow-sm transition-colors hover:tw-bg-slate-50 hover:tw-text-slate-900 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-slate-300"

const deleteButtonClassName =
	"tw-inline-flex tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-red-200 tw-bg-white tw-p-1.5 tw-text-red-500 tw-shadow-sm transition-colors hover:tw-bg-red-50 hover:tw-text-red-700 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-red-200"

export default function LotRow({ lot, isEven, reload, onDeleteRequest }) {
	const [lotNumber, setLotNumber] = useState(lot.lotNumber)
	const [acquireDate, setAcquireDate] = useState(lot.acquireDate)
	const [expireDate, setExpireDate] = useState(lot.expireDate)
	const [quantity, setQuantity] = useState(lot.quantity)
	const [lotQuantity, setLotQuantity] = useState(lot.lotQuantity)

	const [isEditing, setIsEditing] = useState(false)

	const handleIsEditing = () => {
		setIsEditing(prev => !prev)
	}

	const submitLotEdition = async () => {
		await api.put(`/lotes/edit/${lot._id}`, {
			lotNumber: lotNumber,
			expireDate: expireDate,
			acquireDate: acquireDate,
			quantity: quantity,
			product: lot.product,
			lotQuantity: lotQuantity,
		})
		setIsEditing(false)
		reload("Lote editado correctamente")
	}

	const backgroundColor = isEven ? "backgound-veryLight" : ""

	const Td = ({ children }) => {
		return (
			<td
				className={`${backgroundColor}`}
				style={{
					padding: "8px"
				}}
			>
				{children}
			</td>
		)
	}

	if (isEditing) {
		return (
			<tr>
				<Td>
					<input
						name="lotNumber"
						className="input-LotRow no-arrows"
						onChange={e => setLotNumber(e.target.value)}
						value={lotNumber}
						type="text"
					/>
				</Td>
				<Td className="relative">
					<DatePicker
						className="input-LotRow"
						placeholderText="Seleccionar"
						name="acquireDate"
						dateFormat="dd/MM/yyyy"
						input
						type="date"
						selected={acquireDate}
						onChange={date => setAcquireDate(date)}
						autoComplete="off"
					/>
				</Td>
				<Td className="relative">
					<DatePicker
						placeholderText="Seleccionar"
						className="input-LotRow"
						name="acquireDate"
						dateFormat="dd/MM/yyyy"
						input
						type="date"
						selected={new Date(expireDate)}
						onChange={date => setExpireDate(date)}
						autoComplete="off"
					/>
				</Td>
				<Td>
					<input
						name="quantity"
						className="input-LotRow no-arrows"
						onChange={e => setQuantity(e.target.value)}
						value={quantity}
						type="number"
					/>
				</Td>
				<Td>
					<input
						name="lotQuantity"
						className="input-LotRow no-arrows"
						onChange={e => setLotQuantity(e.target.value)}
						value={lotQuantity}
						type="number"
					/>
				</Td>
				<Td>
					<button
						type="button"
						className={iconButtonClassName}
						onClick={submitLotEdition}
					>
						<span className="color-green">✔</span>
					</button>
				</Td>
			</tr>
		)
	} else {
		return (
			<tr>
				<Td>{lotNumber}</Td>
				<Td>{`${new Date(acquireDate).getDate()}/${new Date(acquireDate).getMonth() + 1}/${new Date(acquireDate).getFullYear()}`}</Td>
				<Td>{`${new Date(expireDate).getDate()}/${new Date(expireDate).getMonth() + 1}/${new Date(expireDate).getFullYear()}`}</Td>
				<Td>{quantity}</Td>
				<Td>{lotQuantity}</Td>
				<Td>
					<div className="tw-flex tw-items-center tw-gap-2">
						<button
							type="button"
							className={iconButtonClassName}
							onClick={handleIsEditing}
							aria-label="Editar lote"
						>
							<PencilSquareIcon className="tw-h-4 tw-w-4" />
						</button>
						<button
							type="button"
							className={deleteButtonClassName}
							onClick={() => onDeleteRequest?.(lot)}
							aria-label="Eliminar lote"
						>
							<TrashIcon className="tw-h-4 tw-w-4" />
						</button>
					</div>
				</Td>
			</tr>
		)
	}
}
